import { useEffect } from "react";
import { refrescarLaCajaOffline } from "@/platform";
import { useAuthUser } from "@/context/auth/AuthContext";
import { esSesionDeCaja } from "@/context/caja/sesionDeCaja";
import { useBffAxios } from "@/context/axios/AxiosContext";

// El borde evalúa el flag con el token de la sesión (trd-bff#350): la ruta no
// es pública. Relativa a `BFF_API_BASE`, que ya trae `/api/v1`.
const RUTA_DE_LOS_FLAGS = "/feature-flags";

/**
 * Con una sesión de verdad, le pregunta al BFF si la caja offline está prendida
 * y deja la respuesta para la próxima vez que se abra la app (`OFFLINE_ENABLED`).
 * Sin sesión no hay flags: el BFF los evalúa con el usuario, el negocio y la org
 * del token, así que la caja sin sesión (la entrada con PIN) no pregunta. Sólo en
 * el escritorio: en la web `refrescarLaCajaOffline` no hace nada.
 */
export function useRefrescarLaCajaOffline() {
  const user = useAuthUser();
  const sesion = esSesionDeCaja(user) ? undefined : user;
  const userId = sesion?.id as string | undefined;
  const businessId = sesion?.businessId as string | undefined;
  const axios = useBffAxios();

  useEffect(() => {
    if (!userId || !businessId) return;
    void refrescarLaCajaOffline(
      async () => (await axios.get(RUTA_DE_LOS_FLAGS)).data
    );
  }, [userId, businessId, axios]);
}
